import { Component, Input } from '@angular/core';
import { Report } from '../../../models/report.model';

@Component({
  selector: 'app-photographies-read-mode',
  templateUrl: './photographies-read-mode.component.html',
  styleUrls: ['./photographies-read-mode.component.scss'],
})
export class PhotographiesReadModeComponent {
  @Input() photographies!: Report.Photographs;

  fixedIndexes = Array.from({ length: 6 }, (_, i) => i);
  getPhotoByIndex(index: number): string | undefined {
    return this.photographies?.photographs?.find((p) => p.index === index)
      ?.photo;
  }

  getTitleByIndex(index: number): string | undefined {
    return this.photographies?.photographs?.find((p) => p.index === index)
      ?.title;
  }
}
